import pool from "./pool";

const FLOAT = new Float32Array(1);
const INT = new Uint32Array(FLOAT.buffer);

const GL_UNSIGNED_SHORT = 5123;

export default function convertToHalfFloat(array) {
  const ushorts = pool.allocType(GL_UNSIGNED_SHORT, array.length);

  for (let i = 0; i < array.length; ++i) {
    if (isNaN(array[i])) {
      ushorts[i] = 0xffff;
    } else if (array[i] === Infinity) {
      ushorts[i] = 0x7c00;
    } else if (array[i] === -Infinity) {
      ushorts[i] = 0xfc00;
    } else {
      FLOAT[0] = array[i];
      const x = INT[0];

      const sgn = (x >>> 31) << 15;
      const exp = ((x << 1) >>> 24) - 127;
      const frac = (x >> 13) & ((1 << 10) - 1);

      if (exp < -24) {
        // round non-representable denormals to 0
        ushorts[i] = sgn;
      } else if (exp < -14) {
        // handle denormals
        const s = -14 - exp;
        ushorts[i] = sgn + ((frac + (1 << 10)) >> s);
      } else if (exp > 15) {
        // round overflow to +/- Infinity
        ushorts[i] = sgn + 0x7c00;
      } else {
        // otherwise convert directly
        ushorts[i] = sgn + ((exp + 15) << 10) + frac;
      }
    }
  }

  return ushorts;
}
